export const ROLE_LABEL = {
  admin: "Administrator",
  panitia: "Panitia",
  ppdp: "PPDP",
  rt: "Ketua RT",
  rw: "Ketua RW",
};

export const STATUS_LABEL = {
  ACTIVE: "Aktif",
  MENINGGAL: "Meninggal",
  PINDAH_DOMISILI: "Pindah Domisili",
  DATA_GANDA: "Data Ganda",
  PERLU_VERIFIKASI: "Perlu Verifikasi",
  RUMAH_KOSONG: "Rumah Kosong",
};

export const STATUS_LIST = Object.keys(STATUS_LABEL).filter((s) => s !== "RUMAH_KOSONG");

export const STATUS_BADGE_CLASS = {
  ACTIVE: "bg-emerald-100 text-emerald-800 border-emerald-200",
  MENINGGAL: "bg-slate-200 text-slate-700 border-slate-300",
  PINDAH_DOMISILI: "bg-slate-200 text-slate-700 border-slate-300",
  DATA_GANDA: "bg-red-100 text-red-800 border-red-200",
  PERLU_VERIFIKASI: "bg-amber-100 text-amber-800 border-amber-200",
  RUMAH_KOSONG: "bg-slate-200 text-slate-700 border-slate-300",
};

export const KAWIN_LABEL = { B: "Belum Kawin", S: "Kawin", P: "Pernah Kawin" };
export const KELAMIN_LABEL = { L: "Laki-laki", P: "Perempuan" };

export const DISABILITAS_LABEL = {
  0: "Tidak ada",
  1: "Tuna Daksa",
  2: "Tuna Netra",
  3: "Tuna Rungu/Wicara",
  4: "Tuna Grahita",
  5: "Lainnya",
};

export const CHANGE_TYPE_LABEL = {
  BARU: "Pemilih Baru",
  UBAH: "Ubah Data",
  STATUS: "Ubah Status",
};

export const CHANGE_STATUS_LABEL = {
  PENDING: "Menunggu Verifikasi",
  APPROVED: "Disetujui",
  REJECTED: "Ditolak",
};
